import { writable } from 'svelte/store';

export const idcliente_serie = writable(0);
export const nombre_cliente = writable(0);